import AzureConfigService from 'azure/azure.config'
import { azureFormat, IAzureConfig } from 'azure/azure-format.util'

export const useAzureConfigService = (): {
  getAzureResponse: <T>(key: string) => Promise<IAzureConfig<T>>
} => {
  const getAzureResponse = async <T>(key: string): Promise<IAzureConfig<T>> => {
    const azureClient = new AzureConfigService()
    const azureRes = await azureClient.getAzureSetting({ key })
    const formattedRes = azureFormat<T>(azureRes)
    return formattedRes
  }

  return { getAzureResponse }
}
